// Collection of everything related to "errors" with Internet Explorer
export default class Msie {
  constructor() {
    this.isIe = false
    this.normalMap = document.querySelectorAll('.svg-map')
    this.grayMap = document.querySelectorAll('.gray-map')
    this.main = this.main.bind(this)
    this.checkUserAgent = this.checkUserAgent.bind(this)
    this.changeMapSizes = this.changeMapSizes.bind(this)

    this.main()
  }
  main() {
    this.isIe = this.checkUserAgent()
    if (this.isIe) {
      this.changeMapSizes()
    }
  }
  changeMapSizes() {
    // All different maps needs fixed height and width, else they wont
    // display properly
    if (this.normalMap.length > 0) {
      for (const item of this.normalMap) {
        item.style.cssText = 'height: 577px; width: 700px; display: block;'
      }
    }
    if (this.grayMap.length > 0) {
      for (const item of this.grayMap) {
        item.style.cssText = 'height: 577px; width: 700px; display: block;'
      }
    }
  }
  checkUserAgent() {
    const ua = window.navigator.userAgent
    const msie = ua.indexOf('MSIE ')
    const edge = ua.indexOf('Edge') > -1
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
      return true
    if (edge) return true
    else return false
  }
}
